import type { Signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable } from 'rxjs';

import { LanguageListItemModel } from '../../models';
import { LoadGlobalLanguagesList } from '../actions';
import { GlobalLanguagesSelectors } from '../selectors';

@Injectable({ providedIn: 'root' })
export class GlobalLanguagesStoreService {
  private store = inject(Store);

  get languagesList(): Signal<LanguageListItemModel[]> {
    return this.store.selectSignal(GlobalLanguagesSelectors.languageList);
  }

  get formattedLanguages(): Signal<LanguageListItemModel[]> {
    return this.store.selectSignal(
      GlobalLanguagesSelectors.formattedLanguagesList,
    );
  }

  get languagesListLoadingError$(): Observable<string | null> {
    return this.store.select(GlobalLanguagesSelectors.languageListLoadedError);
  }

  get languagesListLoaded$(): Observable<boolean> {
    return this.store.select(GlobalLanguagesSelectors.languageListLoaded);
  }

  @Dispatch()
  loadGlobalLanguagesList = () => new LoadGlobalLanguagesList();
}
